export default __webpack_public_path__ + "static/media/08.8d7cd50d.jpg";